import {
  CheckEquipmentEverywhereRes,
  CheckReplacedEquipmentEverywhereRes,
  EquipmentOption,
  EquipmentTable,
  EquipmentTableParams,
  FullEquipment,
  SummaryItem,
} from '../types/equipment.types'
import buildParams from '../utils/utils/buildParams'
import { CreateEquipmentForm } from '../views/Equipment/hooks/useCreateEquipment'
import { apiRequest, getUrl } from './ApiService'

export const EQUIPMENT_KEYS = {
  GET_EQUIPMENTS: 'get-equipments',
  GET_SUMMARY: 'get-summary',
  GET_HISTORY: 'get-history',
  SINGLE_EQUIPMENT: 'get-single-equipment',
  CHECK_SN_EVERYWHERE: 'check-sn-everywhere',
  CHECK_EQUIPMENT_EVERYWHERE: 'check-equipment-everywhere',
  GET_SELECT_RECEIVERS: 'get-select-receivers',
  MARK_AS_DEFECT: 'mark-as-defect',
  REPLACE_EQUIPMENT: 'replace-equipment',
  GET_PLACEMENTS: 'get-placements',
}

export const getEquipments = (
  params: EquipmentTableParams,
): Promise<EquipmentTable> => {
  const queryStingParams = buildParams(params)
  return apiRequest({
    url: getUrl(`/catalog/assets/receivers/paged?${queryStingParams}`),
    method: 'GET',
  })
}

export const getEquipmentsSummary = (): Promise<SummaryItem[]> => {
  return apiRequest({
    url: getUrl(`/catalog/assets/receivers/locations/summary`),
    method: 'GET',
  })
}

export const getSingleEquipment = (id: number): Promise<FullEquipment> => {
  return apiRequest({
    url: getUrl(`/catalog/assets/receivers/${id}`),
    method: 'GET',
  })
}

export const checkEquipmentEverywhere = (params: {
  sn?: string
  smartCartId?: string
}): Promise<CheckEquipmentEverywhereRes> => {
  const queryStingParams = buildParams(params)

  return apiRequest({
    url: getUrl(`/catalog/assets/receivers/lookup/edit?${queryStingParams}`),
    method: 'GET',
  })
}

export const checkReplacedEquipmentEverywhere = (params: {
  smartCardId?: string
}): Promise<CheckReplacedEquipmentEverywhereRes> => {
  const queryStingParams = buildParams(params)

  return apiRequest({
    url: getUrl(
      `/catalog/assets/smart-cards/lookup/status?${queryStingParams}`,
    ),
    method: 'GET',
  })
}

export const createEquipment = (
  body: CreateEquipmentForm,
): Promise<CheckEquipmentEverywhereRes> => {
  return apiRequest({
    url: getUrl(`/catalog/assets/receivers`),
    method: 'POST',
    jsonBody: body,
  })
}

export const replaceEquipment = (body: {
  receiverIds: number[]
  toWarehouseId: number
}): Promise<void> => {
  return apiRequest({
    url: getUrl(`/catalog/assets/receivers/transfer/group`),
    method: 'POST',
    jsonBody: body,
  })
}

export const changeEquipmentCasId = (
  id: number,
  body: {
    casNumber: string
    editReason: string
  },
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/catalog/assets/receivers/${id}/embedded-card`),
    method: 'POST',
    jsonBody: body,
  })
}

export const getEquipmentHistory = (id: number): Promise<any> => {
  return apiRequest({
    url: getUrl(`/catalog/assets/receivers/${id}/history`),
    method: 'GET',
  })
}

export const getPlacementsCatalog = (): Promise<
  { id: number; code: string }[]
> => {
  return apiRequest({
    url: getUrl(`/inventory/containers/warehouses/lookup`),
    method: 'GET',
  })
}

export const getSelectReceivers = (params: {
  sn: string
  size: number
}): Promise<EquipmentOption[]> => {
  const queryStingParams = buildParams(params)

  return apiRequest({
    url: getUrl(`/catalog/assets/receivers/lookup/select?${queryStingParams}`),
    method: 'GET',
  })
}

export const markAsDefect = (ids: number[]) => {
  return apiRequest({
    url: getUrl('/catalog/assets/receivers/defect/group'),
    method: 'POST',
    jsonBody: { receiverIds: ids },
  })
}

export const markAsAvailable = (id: number) => {
  return apiRequest({
    url: getUrl(`/catalog/assets/receivers/${id}/defect/clear`),
    method: 'POST',
  })
}
